import colors from "colors";
import { IconProps } from "./types";

export default function IcoArrowRight({
	color = colors.neutral["low-pure-500"],
	size = "28"
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 12H20M20 12L12 20M20 12L12 4"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
